import {Fragment, PureComponent} from 'react'
import PropTypes from 'prop-types'

import DivLeftAlign from "../../../../../shared/components/Styled/DivLeftAlign.jsx"
import H6TitleLeftAlign from "../../../../../shared/components/Styled/H6TitleLeftAlign.jsx"
import ParagraphLeftAlign from "../../../../../shared/components/Styled/ParagraphLeftAlign.jsx"
import PrimaryButton from "../../../../../shared/components/Styled/Buttons/PrimaryButton.jsx"
import ParagraphRightAlign from "../../../../../shared/components/Styled/ParagraphRightAlign.jsx"
import FreelanceAgent from "../../../../components/Agent/FreelanceAgent.jsx"
import H5TitleLeftAlign from "../../../../../shared/components/Styled/H5TitleLeftAlign.jsx"
import UploadCvForm from "../../../../components/Forms/UploadCvForm/UploadCvForm.jsx"
import ConfirmModal from "../../../../../shared/components/Modals/ConfirmModal/ConfirmModal.jsx"
import {toastr} from 'react-redux-toastr'
import api from "../../../../../api"
import conf from "../../../../conf.js"
import {isUserFreelance} from "../../../../../shared/services/userService"
import Loader from "../../../../../shared/components/Loader/Loader.jsx"

export default class Introduction extends PureComponent {
  static propTypes = {
    currentUser: PropTypes.object.isRequired,
    freelance: PropTypes.object.isRequired,
    submit: PropTypes.func.isRequired,
    nextPage: PropTypes.func.isRequired,
    history: PropTypes.object.isRequired,
  }

  constructor(props) {
    super(props)
    this.state = {
      showConfirmModal: false,
      loading: false,
    }
  }

  handleCvUploadSuccess = (cv) => {
    this.props.submit({
      freelance: {
        ...this.props.freelance,
        cv: cv
      }
    })
  }

  isTimeoutError = (e) => e && [408, 504, 524].includes(e.status)

  handleAiConsentAccept = async () => {
    this.setState({ showConfirmModal: false, loading: "Traitement des données en cours..." })
    try {
      const response = await api.freelances.ai({ freelance: this.props.freelance.id })
      if (response.data && response.data.status === 'success') {
        this.props.history.push({
          pathname: '/create/freelance/cv-data-comparison',
          state: {
            analyse: response.data,
            freelance: this.props.freelance,
            user: this.props.currentUser
          }
        })
      }
    } catch (e) {
      console.error(e)
      if (this.isTimeoutError(e)) {
        toastr.error(
          'Délai d\'analyse dépassé',
          `Essayez avec un fichier moins volumineux. Si le problème persiste, contactez l'administrateur : ${conf.site.emails.contact}`
        )
        return
      }
      toastr.error('Erreur lors de l\'analyse du CV')
    } finally {
      this.setState({ loading: false })
    }
  }

  render() {
    const { freelance, currentUser } = this.props
    const isFreelance = isUserFreelance(currentUser)
    const hasCv = !!freelance.cv?.original

    return (
      <Fragment>
        <H5TitleLeftAlign title="Finalisation de votre profil"/>
        <DivLeftAlign>
            Plus qu'une étape avant de valider votre profil ! Pour rappel, <strong>toutes les informations que nous allons vous demander sont primordiales
            pour valider votre profil et nous permettre d'avoir</strong> :
          <ul>
            <li>Un <strong>référencement efficace</strong> pour le moteur de recherche, afin que vous remontiez en première page pour les recherches pertinentes</li>
            <li>Une <strong>lecture rapide</strong> des différents profils</li>
            <li>Une <strong>valorisation</strong> de l'ensemble des profils</li>
          </ul>
        </DivLeftAlign>

        {isFreelance && (
          <div className="ai-autocompletion-section my-4 p-3 border rounded bg-light">
            {hasCv ? (
              <div className="text-center">
                <ParagraphLeftAlign className="mb-2">
                  <strong>Gagnez du temps !</strong> Nous avons détecté votre CV. Souhaitez-vous que nous utilisions l'IA pour pré-remplir votre profil à partir de celui-ci ?
                </ParagraphLeftAlign>
                <PrimaryButton onClick={() => this.setState({ showConfirmModal: true })}>
                  Utiliser mon CV pour compléter mon profil
                </PrimaryButton>
              </div>
            ) : (
              <div className="text-center">
                <ParagraphLeftAlign className="mb-2">
                  <strong>Gagnez du temps !</strong> Déposez votre CV et utilisez l'IA pour pré-remplir votre profil.
                </ParagraphLeftAlign>
                <UploadCvForm
                  className="upload-container"
                  freelanceId={freelance.id}
                  cv={freelance.cv}
                  history={this.props.history}
                  freelance={freelance}
                  user={currentUser}
                  currentUser={currentUser}
                  redirectionUrl="/create/freelance/cv-data-comparison"
                  showAiConsent={true}
                  onUploadSuccess={this.handleCvUploadSuccess}
                />
              </div>
            )}
          </div>
        )}

        <H6TitleLeftAlign title="La complétude de ces informations se divise en 3 étapes"/>
        <ParagraphLeftAlign text={"1) Une présentation synthétique de votre profil"}/>
        <ParagraphLeftAlign text={"2) Renseigner vos diplômes, certifications, langues etc."}/>
        <ParagraphLeftAlign text={"3) Une description de vos expériences et/ou missions"}/>

        <ParagraphLeftAlign className={'line-height-sm mt-4'}>
          <strong>Attention : je vous conseille fortement de réaliser ces étapes depuis un ordinateur et non depuis votre téléphone !</strong>
        </ParagraphLeftAlign>

        {(freelance.agent && freelance.agent.id) &&
          <div className="mt-4">
            <FreelanceAgent agentId={freelance.agent_id ? freelance.agent_id: freelance.agent.id}/>
          </div>
        }

        <ParagraphRightAlign className={'mt-4'}>
          <PrimaryButton onClick={this.props.nextPage}>
            J'ai compris
          </PrimaryButton>
        </ParagraphRightAlign>

        <ConfirmModal
          isOpen={this.state.showConfirmModal}
          header="Analyse intelligente de votre CV"
          body={`<p>
            <strong>Gagnez du temps :</strong> en important votre CV, vous acceptez que son contenu soit <strong>analysé automatiquement par une IA</strong> pour structurer et enrichir votre profil en quelques secondes.
            <ul>
              <li><strong>Confidentialité :</strong> Vos données sont traitées exclusivement en <strong>France</strong> via des solutions sécurisées (<strong>Mistral AI</strong>).</li>
              <li><strong>Éthique :</strong> Aucune revente de données. Utilisation strictement limitée à la création de votre profil.</li>
              <li><strong>Contrôle :</strong> Vous gardez un droit de suppression total à tout moment.</li>
            </ul>
          </p>
          <div class="callout callout-warning">
            <p>L'analyse peut prendre jusqu'à 2 minutes si le fichier contient beaucoup d'informations ou une mise en page particulière.</p>
          </div>`}
          confirmText="J'accepte l'analyse"
          cancelText="Saisir manuellement"
          confirmAction={this.handleAiConsentAccept}
          onCancel={() => this.setState({ showConfirmModal: false })}
          closeModal={() => this.setState({ showConfirmModal: false })}
        />
        <Loader visible={this.state.loading}>{this.state.loading}</Loader>
      </Fragment>
    )
  }
}
